import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Box, Tab, Tabs } from '@mui/material';
import QuestionTranslationOverridesEditor from './QuestionTranslationOverridesEditor';
import { useStores } from '../../../hooks/use-stores';

function QuestionPreviewTabbedContent({
    customizable,
    previewContent,
    language,
    companyId,
    partnerId,
    customizeSaveTo,
    definition,
    questionId,
    questionName,
}) {
    const { brandingStore } = useStores();
    const [activeTab, setActiveTab] = useState('preview');

    // Subscribe so Preview tab re-renders when translation overrides change.
    void brandingStore.translationPreviewRevision;

    if (!customizable) {
        return previewContent;
    }

    return (
        <Box
            className="question-preview-tabbed"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                overflow: 'hidden',
            }}
        >
            <Tabs
                value={activeTab}
                onChange={(_, value) => setActiveTab(value)}
                sx={{ px: 2, borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}
            >
                <Tab value="preview" label="Preview" />
                <Tab value="customize" label="Customize" />
            </Tabs>
            <Box
                sx={{
                    flex: 1,
                    minHeight: 0,
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    position: 'relative',
                }}
            >
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflow: 'auto',
                        display: activeTab === 'preview' ? 'flex' : 'none',
                        flexDirection: 'column',
                    }}
                >
                    {previewContent}
                </Box>
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0,
                        overflow: 'auto',
                        display: activeTab === 'customize' ? 'flex' : 'none',
                        flexDirection: 'column',
                        p: 2,
                    }}
                >
                    <QuestionTranslationOverridesEditor
                        active={activeTab === 'customize'}
                        language={language}
                        companyId={companyId}
                        partnerId={partnerId}
                        customizeSaveTo={customizeSaveTo}
                        definition={definition}
                        questionId={questionId}
                        questionName={questionName}
                    />
                </Box>
            </Box>
        </Box>
    );
}

export default observer(QuestionPreviewTabbedContent);
